import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default _ref => {
  let {
    components,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, `请尽可能详尽地说明这个需求的用例和场景。最重要的是：解释清楚是怎样的`, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "p"
  }, `用户体验需求`), `催生了这个功能上的需求。`), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, `Ant Design 的一个重要设计原则是保持 API 的简洁和直接。通常来说，我们只考虑添加在现有的 API 下无法轻松实现的功能。新功能的用例也应当足够常见。`));
};